module.exports = __webpack_public_path__ + "static_wap/img/myBg.bdf9dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/myBg.png
// module id = 2L+0
// module chunks = 1